import { useEffect, useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

const STORAGE_KEY = 'intelhub_onboarding_done'

const STEPS = [
  {
    title: 'Welcome to IntelHub',
    body: 'Your CISO intelligence hub. Let us walk you through the essentials.',
  },
  {
    title: 'Sidebar navigation',
    body: 'Use the left sidebar to jump between Intelligence, Analytics, and Regulatory views. Sections group related pages.',
  },
  {
    title: 'Command palette',
    body: 'Press ⌘K (or Ctrl+K) any time to search pages or fire actions like "Toggle theme".',
  },
] as const

export interface OnboardingFlowProps {
  forceOpen?: boolean
}

export function OnboardingFlow({ forceOpen }: OnboardingFlowProps) {
  const [open, setOpen] = useState(false)
  const [step, setStep] = useState(0)

  useEffect(() => {
    if (forceOpen) {
      setOpen(true)
      return
    }
    try {
      const dismissed = localStorage.getItem(STORAGE_KEY)
      if (!dismissed) setOpen(true)
    } catch {
      setOpen(true)
    }
  }, [forceOpen])

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1')
    } catch {
      /* ignore */
    }
    setOpen(false)
  }

  const isLast = step === STEPS.length - 1

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) dismiss() }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{STEPS[step].title}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground py-2">{STEPS[step].body}</p>
        <div className="text-xs text-muted-foreground" aria-live="polite">
          Step {step + 1} of {STEPS.length}
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={dismiss}>Skip</Button>
          {!isLast ? (
            <Button onClick={() => setStep((s) => s + 1)}>Next</Button>
          ) : (
            <Button onClick={dismiss}>Get started</Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
